import { RequirementOutcomeItem } from 'modules/analyse/types/RequirementOutcomeItem';

export const sortRequirementOutcomes = (
  requirementOutcomes: RequirementOutcomeItem[]
) => {
  const sortRequirementsByText = requirementOutcomes.sort((a, b) => {
    const aText = a.analysisRequirement?.originalRequirementText ?? '';
    const bText = b.analysisRequirement?.originalRequirementText ?? '';
    if (aText < bText) {
      return -1;
    }
    if (aText > bText) {
      return 1;
    }
    return 0;
  });

  const sortedRequirementOutcomes = sortRequirementsByText.sort((a, b) => {
    // Sort by weight
    const aWeight = a.analysisRequirement?.weight ?? 0;
    const bWeight = b.analysisRequirement?.weight ?? 0;
    if (aWeight > bWeight) {
      return -1;
    }
    if (aWeight < bWeight) {
      return 1;
    }
    return 0;
  });

  const splitRequirements = sortedRequirementOutcomes.reduce(
    (acc, requirementOutcome) => {
      if (requirementOutcome.analysisRequirement?.isMandatory) {
        acc.mandatory.push(requirementOutcome);
        if (requirementOutcome.isMet) {
          acc.mandatoryMet++;
        }
      } else {
        acc.optional.push(requirementOutcome);
        if (requirementOutcome.isMet) {
          acc.optionalMet++;
        }
      }
      return acc;
    },
    { mandatory: [], mandatoryMet: 0, optional: [], optionalMet: 0 } as {
      mandatory: RequirementOutcomeItem[];
      mandatoryMet: number;
      optional: RequirementOutcomeItem[];
      optionalMet: number;
    }
  );

  return splitRequirements;
};
